var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPagePrevDisable(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 11,
    height: 14,
    viewBox: "0 0 11 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Polygon 7",
    d: "M0.499999 7.86602C-0.166667 7.48112 -0.166667 6.51887 0.499999 6.13397L9.5 0.937817C10.1667 0.552917 11 1.03404 11 1.80384L11 12.1962C11 12.966 10.1667 13.4471 9.5 13.0622L0.499999 7.86602Z",
    fill: "#8A8694"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPagePrevDisable);
export default __webpack_public_path__ + "static/media/PagePrevDisable.e9ac9f494129d1258c4542dadd02ed10.svg";
export { ForwardRef as ReactComponent };